import Axios from "axios";
import { message } from "antd";

export default function putReqCompany(id) {
  return (dispatch) => {
    dispatch({
      type: "Loading",
      payload: true,
    });
    Axios({
      method: "PUT",
      url: `${process.env.REACT_APP_BASE_URL}/update-reqCompany`,
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data:{
        id:id,
        added:true
      }
    })
      .then((response) => {
        window.location.reload();
        return dispatch({
          type: "Loading",
          payload: false,
        });
      })
      .catch((err) => {
        dispatch({
          type: "Loading",
          payload: false,
        });
        message.error("Something Went Wrong Please try again Later");
      });
  };
}
